import { baseURL as envBaseURL, escalationTeamMember as envEscalationTeam } from './env';

let token = "";

export const setToken = (newToken) => {
  token = newToken;
};

export const getToken = () => {
  return token;
};

export const baseURL = envBaseURL;

export const GOOGLE_OAUTH_CLIENT_ID =
  "95993965258-rklc6lesppdcqda08sli02fk4rv3h296.apps.googleusercontent.com";

export const escalationTeamMember = envEscalationTeam;

